var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleCustomization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6b2839e5-a3c0-4575-9d88-ffb3bd5eb152",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.96,
    height: 12.44,
    viewBox: "0 0 13.96 12.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-0115ec19-b16f-46cb-b6ed-9033aa02217a",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.77,12.44H.19c-.11,0-.19-.09-.19-.19s.09-.19.19-.19h13.57c.11,0,.19.09.19.19s-.09.19-.19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74,10.96s-.07-.01-.1-.03c-.05-.03-.08-.09-.09-.15l-.14-2.22s0-.08.03-.12L8.86.09c.06-.09.18-.11.27-.06l2.21,1.43s.07.07.08.12c.01.05,0,.1-.03.14l-5.42,8.36s-.05.06-.09.08l-2.08.78s-.04.01-.07.01ZM3.8,8.6l.12,1.9,1.77-.67L10.97,1.68l-1.89-1.23L3.8,8.6ZM5.82,9.98h0,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleCustomization);
export default __webpack_public_path__ + "static/media/icon_module_customization.ce943c016bcde4298482d4853f1eae77.svg";
export { ForwardRef as ReactComponent };